import React from "react";
import { Button, Card } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import { RxExclamationTriangle } from "react-icons/rx";
import { trackEvent } from "../utils/mixpanel";
import { IoArrowForward } from "react-icons/io5";
import { Link } from "react-router-dom";
import { IoSend } from "react-icons/io5";
import { useState } from "react";
import PackageContactForm from "../pages/PackageContactForm";
import { Modal } from "react-bootstrap";

const SubscriptionCard = ({
  singlePackage,
  index,
  purchasedPackage,
  isExpired,
  subscriptionType,
  isCouponChecked,
  onCheckboxChange,
  couponCode,
  onCouponChange,
  onApplyCoupon,
  onSelectPlan,
  onCancelSubscription,
  blankCouponField,
  incorrectCouponEntered,
  correctCouponEntered,
  couponMessage,
  couponData,
  purchasedPackageData,
}) => {
  console.log("[SubscriptionCard] purchasedPackage:", purchasedPackage);
  console.log("[SubscriptionCard] singlePackage:", singlePackage);
  console.log("[SubscriptionCard] isExpired:", isExpired);

  const isActive = purchasedPackage?.id === singlePackage?.id && !isExpired;
  console.log("[SubscriptionCard] isActive:", isActive, "for package:", singlePackage?.package_name);

  // Determine the active subscription type, falling back to the package's own type
  const activeSubscriptionType =
    purchasedPackageData?.subscription_type ||
    purchasedPackageData?.package?.package_type ||
    purchasedPackage?.package_type;
  // For custom (owner-specific) packages, match by package_type regardless of subscription_type
  const isCustomPackage =
    singlePackage?.package_type === "customer_specific_owner" ||
    singlePackage?.package_type === "customer_specific_personal";
  const activePackageType =
    purchasedPackageData?.package?.package_type || purchasedPackage?.package_type;
  const normalizedActiveType =
    activePackageType === "customer_specific_owner" ||
      activeSubscriptionType === "customer_specific_owner"
      ? "customer_specific_personal"
      : activePackageType === "customer_specific_personal" ||
        activeSubscriptionType === "customer_specific_personal"
        ? "customer_specific_personal"
        : activeSubscriptionType;
  const isCurrentTab = isCustomPackage
    ? subscriptionType === "customer_specific_personal" &&
    (activePackageType === "customer_specific_owner" ||
      activePackageType === "customer_specific_personal")
    : normalizedActiveType === subscriptionType;

  const [showContactForm, setShowContactForm] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  return (
    <div
      className="col-12 col-md-6 col-lg-4 col-xxl-3"
      key={`pricingCard${index}`}
    >
      <Card
        className={`subscriptionCard h-100 ${isActive && isCurrentTab
          ? "subscriptionCardactive"
          : ""
          }`}
      >
        <div className="card-header">
          <Card.Title>{singlePackage.package_name}</Card.Title>
          <p className="d-flex align-items-center justify-content-between">
            {singlePackage.package_name === "Starter"
              ? "Free"
              : singlePackage.package_name === "Enterprise"
                ? "Custom Price"
                : `$${(couponData !== null) &
                  (couponData?.package_id === singlePackage?.id)
                  ? couponData?.package_price_after_discount
                  : subscriptionType === "monthly"
                    ? singlePackage.price_monthly
                    : subscriptionType === "customer_specific_personal"
                      ? singlePackage.price
                      : singlePackage.price_yearly
                }/${subscriptionType === "monthly"
                  ? "mo."
                  : subscriptionType === "customer_specific_personal"
                    ? singlePackage?.duration_type === "year"
                      ? "yr."
                      : "mo."
                    : "yr."
                }`}
            {isActive && isCurrentTab ? (
              <span>
                <FaCheckCircle /> Active
              </span>
            ) : (
              ""
            )}
          </p>
        </div>
        <Card.Body>
          {Number(singlePackage.is_free_trail) === 1 &&
            singlePackage.package_name !== "Starter" &&

            <div className="text-center mb-3">
              <span className="badge bg-success-light text-success px-3 py-2 rounded-pill" style={{ backgroundColor: "#e2f5ec", fontSize: "13px", fontWeight: "600" }}>
                {singlePackage.free_trail_period} {singlePackage.free_trail_period_type || "days"} Free Trial
              </span>
            </div>
          }
          <ul className="package-features-list list-unstyled">
            {/* Connection */}
            {singlePackage.limit_connections_save === 0 ? (
              <li>
                <p>Connections</p>
                <span>{singlePackage.limit_connections_save}</span>
              </li>
            ) : (
              <li>
                <p>Connections</p>
                <span>{singlePackage.limit_connections_save}</span>
              </li>
            )}
            {/*  Card Section */}
            {singlePackage.limit_card_create === 0 ? (
              <li>
                <p>Personal/Business Card</p>
                <span>{singlePackage.limit_card_create}</span>
              </li>
            ) : singlePackage.id === 1 ? (
              <li>
                <p>Personal/Business Card</p>
                <span></span>
              </li>
            ) : (
              <li>
                <p>Personal/Business Card</p>
                <span>{singlePackage.limit_card_create}</span>
              </li>
            )}

            {/* Payments */}
            {singlePackage.limit_payment_create == 0 ? (
              <li>
                <p>Payments cards</p>
                <span>{singlePackage.limit_payment_create}</span>
              </li>
            ) : singlePackage.id === 1 ? (
              <li>
                <p>Payments cards</p>
                <span></span>
              </li>
            ) : (
              <li>
                <p>Payments cards</p>
                <span>{singlePackage.limit_payment_create}</span>
              </li>
            )}

            {/* Emergency Contact */}
            {singlePackage.limit_emergency_contact_create == 0 ? (
              <li>
                <p>Emergency Contacts</p>
                <span>{singlePackage.limit_emergency_contact_create}</span>
              </li>
            ) : singlePackage.id === 1 ? (
              <li>
                <p>Emergency Contacts</p>
                <span></span>
              </li>
            ) : (
              <li>
                <p>Emergency Contacts</p>
                <span>{singlePackage.limit_emergency_contact_create}</span>
              </li>
            )}

            {/* Custom Url */}
            {singlePackage.limit_custom_url_create == 0 ? (
              <li>
                <p>Custom URL</p>
                <span>{singlePackage.limit_custom_url_create}</span>
              </li>
            ) : singlePackage.id === 1 ? (
              <li>
                <p>Custom URL</p>
                <span></span>
              </li>
            ) : (
              <li>
                <p>Custom URL</p>
                <span>{singlePackage.limit_custom_url_create}</span>
              </li>
            )}

            {/* File Upload Url */}
            {singlePackage.limit_file_upload_create == 0 ? (
              <li>
                <p>File Upload URL</p>
                <span>{singlePackage.limit_file_upload_create}</span>
              </li>
            ) : singlePackage.id === 1 ? (
              <li>
                <p>File Upload URL</p>
                <span></span>
              </li>
            ) : (
              <li>
                <p>File Upload URL</p>
                <span>{singlePackage.limit_file_upload_create}</span>
              </li>
            )}
            {singlePackage.limit_memory == 0 ? (
              <li>
                <p>Memory</p>
                <span>{singlePackage.limit_memory}</span>
              </li>
            ) : singlePackage.id === 1 ? (
              <li>
                <p>Memory</p>
                <span></span>
              </li>
            ) : (
              <li>
                <p>Memory</p>
                <span>{singlePackage.limit_memory}</span>
              </li>
            )}
            {singlePackage.limit_form_builder == 0 ? (
              <li>
                <p>Lead Builder</p>
                <span>{singlePackage.limit_form_builder}</span>
              </li>
            ) : singlePackage.id === 1 ? (
              <li>
                <p>Lead Builder</p>
                <span></span>
              </li>
            ) : (
              <li>
                <p>Lead Builder</p>
                <span>{singlePackage.limit_form_builder}</span>
              </li>
            )}

            {singlePackage.limit_medical_id == 0 ? (
              <li>
                <p>Medical ID</p>
                <span>{singlePackage.limit_medical_id}</span>
              </li>
            ) : singlePackage.id === 1 ? (
              <li>
                <p>Medical ID</p>
                <span></span>
              </li>
            ) : (
              <li>
                <p>Medical ID</p>
                <span>{singlePackage.limit_medical_id}</span>
              </li>
            )}

            {singlePackage.id === 1 &&
              singlePackage.limit_dynamic_qr_code == 0 ? (
              <li>
                <p>Dynamic QR Code</p>
                <span></span>
              </li>
            ) : singlePackage.limit_dynamic_qr_code == 0 ? (
              <li>
                <p>Dynamic QR Code</p>
                <span>{singlePackage.limit_dynamic_qr_code}</span>
              </li>
            ) : (
              <li>
                <p>Dynamic QR Code</p>
                <span>{singlePackage.limit_dynamic_qr_code}</span>
              </li>
            )}

            {singlePackage.limit_dynamic_qr_code_each_function == 0 ? (
              <li>
                <p>Dynamic QR Code Function Limit</p>
                <span>{singlePackage.limit_dynamic_qr_code_each_function}</span>
              </li>
            ) : singlePackage.id === 1 ? (
              <li>
                <p>Dynamic QR Code Function Limit</p>
                <span></span>
              </li>
            ) : (
              <li>
                <p>Dynamic QR Code Function Limit</p>
                <span>{singlePackage.limit_dynamic_qr_code_each_function}</span>
              </li>
            )}

            {/*Custom Button */}
            {singlePackage.enable_custom_buttons == 0 ? (
              <li>
                <p>Custom Button</p>
                <span>
                  {singlePackage.enable_custom_buttons ? "Yes" : "No"}
                </span>
              </li>
            ) : (
              <li>
                <p>Custom Button</p>
                <span>
                  {singlePackage.enable_custom_buttons ? "Yes" : "No"}
                </span>
              </li>
            )}

            {/*Email Notification Button */}
            {/* {singlePackage.enable_email_notifications == 0 ? (
                       <li>
                         <div
                           className="d-flex align-items-center justify-content-between"
                           style={{ color: "var(--primary_text_color)" }}
                         >
                           <p>Email Notification</p>
                           <p>
                             {singlePackage.enable_email_notifications
                               ? "Yes"
                               : "No"}
                           </p>
                         </div>
                       </li>
                       ) : (
                         <li>
                           <div className="d-flex align-items-center justify-content-between">
                             <p>Email Notification</p>
                             <p>
                               {singlePackage.enable_email_notifications
                                 ? "Yes"
                                 : "No"}
                             </p>
                           </div>
                         </li>
                       )} */}
          </ul>
        </Card.Body>
        <Card.Footer>
          {singlePackage.id === 1 ? (
            <p className="noteText mb-3">
              In free mode you can only create one function at a time and
              deleting it allows you to create another.
            </p>
          ) : (
            ""
          )}
          {singlePackage.id === 4 ? (
            <>
              <div className="couponWrapper">
                <div class="form-check form-group text-start mb-3">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckDefault"
                  />
                  <label class="form-check-label" for="flexCheckDefault">
                    Do you have a coupon?
                  </label>
                </div>
              </div>
              <div className="btnWrapper">
                <Link to={`/PackageContactForm/${singlePackage.id}`}>
                  <button className="btn">Contact Us</button>
                </Link>
              </div>
            </>
          ) : isActive && isCurrentTab ? (
            <>
              {singlePackage.id === 1 ? (
                ""
              ) : (
                <Button
                  variant="link"
                  className="text-decoration-none p-0"
                  onClick={onCancelSubscription}
                >
                  Cancel Subscription
                </Button>
              )}
            </>
          ) : (
            <>
              {singlePackage.package_name === "Starter" ||
                singlePackage.id == 7 ? (
                ""
              ) : (
                <div className="couponWrapper mb-3">
                  <div className="form-check form-group text-start mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id={`monthlyCheckbox-${index}`}
                      //   onChange={() => onCheckboxChange(index)}
                      //   checked={hasCouponMonthly[index]}
                      checked={isCouponChecked}
                      onChange={() => onCheckboxChange(index)}
                    // disabled={couponData !== null}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Do you have a coupon?
                    </label>
                  </div>
                  {isCouponChecked && (
                    <div className="input-group form-group">
                      <input
                        type="text"
                        className="form-control coupon-form-control"
                        placeholder="Enter Coupon code"
                        value={couponCode}
                        onChange={(e) => onCouponChange(e.target.value)}
                      />
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={() =>
                          onApplyCoupon(subscriptionType, singlePackage.id)
                        }
                      >
                        <IoSend />
                      </button>
                      {couponData?.package_id === singlePackage?.id ? (
                        <>
                          {blankCouponField && (
                            <div className="failurText">
                              Please enter coupon code
                            </div>
                          )}
                          {couponMessage && (
                            <div className="successText d-block w-100">
                              {couponMessage}
                            </div>
                          )}
                        </>
                      ) : couponMessage ? (
                        <div className="successText d-block w-100">
                          {couponMessage}
                        </div>
                      ) : (
                        ""
                      )}
                      {/* {couponMessage && (
                        <div className="failurText">
                          Sorry, coupon code invalid
                        </div>
                      )} */}
                    </div>
                  )}
                </div>
              )}
              {singlePackage.id == 7 ? (
                // <div className="btnWrapper">
                //   <Link
                //     to={`/PackageContactForm/${singlePackage.id}`}
                //     onClick={() =>
                //       trackEvent("Contact Us Clicked", {
                //         package_id: singlePackage.id,
                //         package_name: singlePackage.package_name,
                //         platform: "web",
                //       })
                //     }
                //   >
                //     <Button variant="outline-primary" className="btn">
                //       Contact Us <IoArrowForward className="ms-2" />
                //     </Button>
                //   </Link>
                // </div>
                <div>
                  <Button
                    variant="outline-primary"
                    className="btn"
                    onClick={() => {
                      setSelectedPackage(singlePackage);
                      setShowContactForm(true);
                      trackEvent("Contact Us Clicked", {
                        package_id: singlePackage.id,
                        package_name: singlePackage.package_name,
                        platform: "web",
                      });
                    }}
                  >
                    Contact Us <IoArrowForward className="ms-2" />
                  </Button>

                  <Modal
                    show={showContactForm}
                    onHide={() => setShowContactForm(false)}
                    size="sm"
                    className="customModal square-modal"
                  >
                    {/* <Modal.Header
                      style={{ borderBottom: "none", width: "fit-content" }}
                    >
                      <Modal.Title
                        style={{
                          fontSize: "20px",
                          fontWeight: "600",
                          color: "#333333",
                        }}
                      >
                        Connect to Us
                      </Modal.Title>
                    </Modal.Header> */}

                    <Modal.Body className="p-0">
                      <PackageContactForm
                        packageId={selectedPackage?.id}
                        onClose={() => setShowContactForm(false)}
                      />
                    </Modal.Body>
                  </Modal>
                </div>
              ) : (
                <div className="btnWrapper">
                  {console.log("singlePackage", singlePackage)}
                  {console.log("subscriptionType", subscriptionType)}
                  <Button
                    variant="outline-primary"
                    className="btn"
                    onClick={() => {
                      trackEvent("Package Selected", {
                        ...singlePackage,
                        billing_cycle: "monthly",
                        platform: "web",
                      });
                      onSelectPlan(
                        singlePackage,
                        // singlePackage?.duration_type === "year"
                        //   ? "yearly"
                        //   : "monthly"
                        subscriptionType === "monthly"
                          ? "monthly"
                          : subscriptionType === "customer_specific_personal"
                            ? singlePackage?.duration_type === "year"
                              ? "yearly"
                              : "monthly"
                            : "yearly"
                      );
                    }}
                  >
                    Select Package <IoArrowForward className="ms-2" />
                  </Button>
                </div>
              )}
            </>
          )}
        </Card.Footer>
      </Card>
    </div>
  );
};

export default SubscriptionCard;
